import Schema from '../helper/schema/index'
import SchemaBase from '../helper/schema/Schema'

/**
 * [Disabled in production and test environment]
 * Check and decorate the vm configs
 * All error found in configs will be thrown
 * @param {object} configs - Mutable VM configs
 */
export default configs => {
  mode(configs)
  data(configs)
  name(configs)
  schemas(configs)
  actions(configs)
  hooks(configs)
  options(configs)
  nestedResource(configs)
  parallelResource(configs)
  tabs(configs)
}

function mode(configs) {
  if (!configs.mode) {
    throw 'View must have `mode`!'
  }
}

function data(configs) {
  if (!configs.data) {
    throw 'View must have `data`!'
  }
  const data = configs.data
  const required = ['name', 'resourceName', 'provider', 'add', 'fetch', 'update']
  for (const key of required) {
    if (!data.hasOwnProperty(key)) {
      throw `Data descriptor must have \`${key}\`!`
    }
  }
}

function name(configs) {
  if (!configs.name) {
    configs.name = configs.data.resourceName
  }
}

function schemas(configs) {
  if (!configs.schema) {
    throw 'View must have `schema`!'
  }
  for (const schema of configs.schema) {
    if (!schema instanceof SchemaBase) {
      throw 'Schema must be constructed by a schema class!'
    }
    if ((
      (schema instanceof Schema.Select) ||
      (schema instanceof Schema.MultiSelect) ||
      (schema instanceof Schema.Tree) ||
      (schema instanceof Schema.CheckTree)
    ) && !schema.items) {
      throw 'Missing items for Select or Tree!'
    }
    if (!schema.options) {
      schema.options = {}
    }
    if (!schema.on) {
      schema.on = {}
    }
  }
}

function actions(configs) {
  if (!configs.actions) {
    configs.actions = []
  }
}

function hooks(configs) {
  if (!configs.hooks) {
    configs.hooks = []
  }
  for (const hook of configs.hooks) {
    if (!hook.options) {
      hook.options = {}
    }
  }
}

function options(configs) {
  if (!configs.options) {
    configs.options = []
  }
}

function nestedResource(configs) {
  if (!configs.nestedResource) {
    configs.nestedResource = []
  }
}

function parallelResource(configs) {
  if (!configs.parallelResource) {
    configs.parallelResource = []
  }
}

function tabs(configs) {
  if (!configs.tabs) {
    configs.tabs = []
  }
}



// WEBPACK FOOTER //
// ./packages/utils/decorateViewConfigs.js